import api from '../utils/api';
import type {
  QueueJob,
  QueueJobsResponse,
  QueueFilters,
  QueueStats,
  ScadenzaReminder
} from '../types/queue.types';
import type { QueryParams } from '../types/common.types';

export const queueService = {
  // Get all queue jobs with pagination and filters
  getJobs: async (params: {
    page?: number;
    limit?: number;
    sort?: string;
    status?: string;
    jobType?: string;
    search?: string;
    failedOnly?: boolean;
  }): Promise<QueueJobsResponse> => {
    // Convert frontend sorting format to backend format
    let sortParam = params.sort;
    if (params.sort && !params.sort.startsWith('-') && !params.sort.startsWith('+')) {
      sortParam = `-${params.sort}`; // Default to descending
    }
    
    const apiParams = {
      page: params.page || 1,
      limit: params.limit || 20,
      sort: sortParam,
      status: params.status,
      jobType: params.jobType,
      search: params.search,
      failedOnly: params.failedOnly
    };
    
    const response = await api.get('/queue/jobs', { params: apiParams });
    return response.data;
  },

  // Get queue statistics
  getStats: async (): Promise<QueueStats> => {
    const response = await api.get('/queue/stats');
    return response.data;
  },

  // Get queue health status
  getHealth: async (): Promise<{
    status: 'healthy' | 'degraded' | 'unhealthy';
    message: string;
    details?: any;
  }> => {
    const response = await api.get('/queue/health');
    return response.data;
  },

  // Get failed jobs for debugging (admin only)
  getFailedJobs: async (limit?: number): Promise<QueueJob[]> => {
    const response = await api.get('/queue/failed', { 
      params: { limit: limit || 10 }
    });
    return response.data;
  },

  // Get scadenze with reminder status and jobs
  getScadenzeReminders: async (): Promise<ScadenzaReminder[]> => {
    const response = await api.get('/queue/scadenze-reminders');
    // Backend returns { scadenzeWithJobs, summary }, we want the array
    return response.data.scadenzeWithJobs || [];
  }
};

export default queueService;